import '@shared/styles/globals.css';
import { mountApp } from '@shared/app/AppRoot';
import { hrmsConfig } from '@/app.config';
import { hrmsRoutes } from '@/routes';

mountApp(hrmsConfig, hrmsRoutes);
